var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WizardInputFieldLayout',{attrs:{"title":"Name"},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('AppTextField',{attrs:{"placeholder":"Enter name","outlined":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }